import { isDefined, isObject, isString } from 'class-validator';

/** A multiselect option may be a primitive or a `{ label, value }` object; empty parts are dropped. */
function dropDownOptionToDisplayPart(item: unknown): string | null {
  if (!isDefined(item)) {
    return null;
  }

  if (isObject(item) && !Array.isArray(item)) {
    const option = item as Record<string, unknown>;
    if (isString(option.label) && option.label.trim() !== '') {
      return option.label.trim();
    }
    if (isDefined(option.value) && (isString(option.value) || typeof option.value === 'number')) {
      const text = String(option.value).trim();
      return text !== '' ? text : null;
    }
    return null;
  }

  const text = String(item).trim();
  return text !== '' ? text : null;
}

/**
 * Resolves multiselect values that may be stored as a JSON string (API / websocket) or as
 * primitives / `{ label, value }` option objects, into plain display parts.
 */
export function normalizeDropDownMultiSelectToDisplayParts(value: unknown): string[] | null {
  let rawItems: unknown[];

  if (Array.isArray(value)) {
    rawItems = value;
  } else if (isString(value)) {
    const trimmed = value.trim();
    if (!trimmed) {
      return [];
    }
    if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
      try {
        const parsed: unknown = JSON.parse(trimmed);
        rawItems = Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        rawItems = [trimmed];
      }
    } else {
      rawItems = [trimmed];
    }
  } else if (!isDefined(value)) {
    return null;
  } else {
    rawItems = [value];
  }

  return rawItems.map(dropDownOptionToDisplayPart).filter((part): part is string => part !== null);
}
